const id_indo5 = {
    common: {
        distributor: "distributor",
        employee: 'pegawai',
        ktp: 'KTP',
        zip: 'kode pos',
        region: 'wilayah',
        customer: 'outlet',
        chain: 'chain',
        channel: 'channel',
        account_name: 'nama rekening',
        account_number: 'nomor rekening',
        project: 'proyek',
        project_admin: 'admin proyek',
        sales: 'sales',
        verified: 'terverifikasi',
    },
    menu: {
        so: "sales order (SO)",
        do: "delivery order (DO)",
        distributor: "distributor",
        sales: "pegawai",
        customer: "outlet",
        assignment: 'penugasan',
        region: 'wilayah',
        chain: 'chain',
        channel: 'channel',
        employee_type: 'tipe pegawai',
        project: 'proyek',
        project_list: 'daftar proyek',
        form_builder: 'form builder',
    },
    so: {
        "detail": "detil sales order (SO)",
        "update_sales": "ubah SO sales",
    },
    do: {
        "detail": "detil delivery order (DO)"
    },
    distributor: {
        "add": "tambah distributor",
        "edit": "ubah distributor",
        "name": "nama distributor",
        "pic": "PIC gudang distributor",
        "phone": "no. telp distributor",
        "fax": "fax distributor",
        "email": "email distributor",
    },
    sales: {
        "add": "tambah pegawai",
        "edit": "ubah pegawai",
        "name": "nama pegawai",
        "phone": "no. telp pegawai",
        "email": "email pegawai",
        "connection": "koneksi outlet",
        "add_connection": "tambah koneksi outlet",
        "delete_connection": "hapus koneksi outlet",
    },
    assignmentsales: {
        "": "jadwal kunjungan",
        "schedule": "daftar jadwal kunjungan",
        "edit_schedule": "ubah jadwal kunjungan",
    },
    assignmentgoods: {
        "": "penempatan SKU",
        "list": "daftar penempatan SKU",
        "edit": "ubah daftar penempatan SKU",
    },
    customer: {
        "add": "tambah outlet",
        "edit": "ubah outlet",
        "name": "nama outlet",
        "phone": "no. telp outlet",
        "email": "email outlet",
        "btype": "jenis usaha",
        "distance": "jarak maksimal (meter)",
        "save_noo": "simpan dan validasi"
    },
    region: {
        "add": "tambah wilayah",
        "edit": "ubah wilayah",
        "name": "nama wilayah",
        "parent": "induk wilayah",
        "search_name": "Cari Nama Wilayah",
    },
    chain: {
        "add": "tambah chain",
        "edit": "ubah chain",
        "name": "nama chain",
        "parent": "induk chain",
        "search_name": "Cari Nama Chain",
    },
    channel: {
        "add": "tambah channel",
        "edit": "ubah channel",
        "name": "nama channel",
        "parent": "induk channel",
        "search_name": "Cari Nama Channel",
    },
    employee_type: {
        "add": "tambah tipe pegawai",
        "edit": "ubah tipe pegawai",
        "name": "nama tipe",
        "search_name": "Cari Nama Tipe",
    },
    project_list: {
        "name": "nama proyek",
        "date": "tanggal proyek",
        "date_new_end_date": "tanggal akhir baru proyek",
        'add': "tambah proyek",
        'edit': "ubah proyek",
        "extend": "perpanjang proyek",
        'view': "detail proyek",
        "distributor": "daftar distributor proyek",
        "add_distributor": "tambah distributor",
        "edit_distributor": "ubah distributor",
        "delete_distributor": "hapus distributor",
        "sku": "daftar SKU proyek",
        "add_sku": "tambah SKU",
        "edit_sku": "ubah SKU",
        "delete_sku": "hapus SKU",
        "customer": "daftar koneksi outlet proyek",
        "edit_customer": "ubah koneksi outlet",
        "sales_visit": "daftar kunjungan sales proyek",
        "sales_visit_upload": "unggah jadwal kunjungan penjualan",
        "add_area": "tambah wilayah | channel | chain",
    },
    "add_sku": "add SKU",
    "edit_sku": "edit SKU",
    form_builder: {
        "name": "nama form",
        'add': "tambah form",
        'edit': "ubah form",
        'add_field': 'tambah field',
        'field_name': 'nama field',
        'field_note': 'catatan input',
        'form_type': 'tipe form',
        'sales_type': 'tipe pegawai',
        'init_value': 'nilai / teks awal',
        'add_option': 'tambah pilihan',
        'add_sku': 'tambah SKU',
        'add_all_sku': 'tambah semua SKU',
        'list_option': 'daftar pilihan',
    },
}

export default id_indo5;